import { clientFetch } from "@/lib/api/client-fetch";
import type { Scroll } from "@/lib/supabase";

export type ScrollPage = {
  items: Scroll[];
  nextCursor: string | null;
  hasMore: boolean;
  limit: number;
};

export type ScrollListParams = {
  folder?: string | null;
  folderId?: string | null;
  limit?: number;
  workspaceId?: string | null;
  archived?: "active" | "include" | "only";
  deleted?: "active" | "include" | "only";
  q?: string | null;
  starredOnly?: boolean;
  inFolderOnly?: boolean;
};

export async function fetchScrollsPage(
  cursor?: string,
  params?: ScrollListParams,
): Promise<ScrollPage> {
  const qs = new URLSearchParams();
  if (cursor) qs.set("cursor", cursor);
  if (params?.folder) qs.set("folder", params.folder);
  if (params?.folderId) qs.set("folder_id", params.folderId);
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.workspaceId) qs.set("workspace_id", params.workspaceId);
  if (params?.archived) qs.set("archived", params.archived);
  if (params?.deleted) qs.set("deleted", params.deleted);
  const qTrim = params?.q?.trim();
  if (qTrim) qs.set("q", qTrim.slice(0, 200));
  if (params?.starredOnly) qs.set("starred", "1");
  if (params?.inFolderOnly) qs.set("in_folder", "1");

  const res = await clientFetch(`/api/scrolls?${qs.toString()}`);
  if (!res.ok) throw new Error("Failed to fetch scrolls");
  const payload = await res.json();
  return payload.data as ScrollPage;
}
